import { createActionGroup, props } from '@ngrx/store';
import * as fromGenerated from '../../../_generated';

export const TeammatesActions = createActionGroup({
  source: 'Teammates',
  events: {
    'Load Teammates': props<{ locale: 'en' | 'fr' }>(),
    'Load Teammates Success': props<{
      teammates: fromGenerated.TeammateView[];
    }>(),
    'Load Teammates Failure': props<{ error: string }>(),
  },
});
